import { useViewModel } from '@/lib/viewModels'
import { ProtectDescriptionViewModel } from './ProtectDescriptionViewModel'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import { ProtectDescription } from './ProtectDescription'
import { useApiService } from '@/lib/apiService'
import { Button } from 'antd'

export interface ProtectDescriptionViewProps {}

const ProtectDescriptionViewWrapper = styled.div``
export const ProtectDescriptionView: React.FC<ProtectDescriptionViewProps> = observer((props) => {
	const apiService = useApiService()
	const { status, actions } = useViewModel({ apiService }, ProtectDescriptionViewModel)
	return (
		<ProtectDescriptionViewWrapper>
			<ProtectDescription
				onClick={() => (status.modalOpen = !status.modalOpen)}
				modalOpen={status.modalOpen}
				initialValues={status.initialValues}
				onSubmit={actions.onSubmit}
				publisherOptions={actions.publisherOptions}
				onSetImageFile={actions.onSetImageFile}
				onSetPdfFile={actions.onSetPdfFile}
			/>
		</ProtectDescriptionViewWrapper>
	)
})
